/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import {
  JOB_EXECUTION_STATUS_ERRORED,
  JOB_EXECUTION_STATUS_QUEUED,
  JOB_EXECUTION_STATUS_RUNNING,
  JOB_EXECUTION_STATUS_SUCCESS,
  JOB_EXECUTION_STATUS_TERMINATED,
} from '../JobExecutionStatus/JobExecutionStatus.types';
import { JOB_TYPE_EXECUTION } from '../JobType/JobType.types';

export type EntityJobExecution = io.TypeOf<typeof JobExecution>;

export const JobExecution = io.type({
  context: io.string,
  ecsTaskId: io.string,
  id: io.string,
  input: io.unknown,
  jobName: io.string,
  status: io.union([
    io.literal(JOB_EXECUTION_STATUS_QUEUED),
    io.literal(JOB_EXECUTION_STATUS_TERMINATED),
    io.literal(JOB_EXECUTION_STATUS_SUCCESS),
    io.literal(JOB_EXECUTION_STATUS_RUNNING),
    io.literal(JOB_EXECUTION_STATUS_ERRORED),
  ]),
  timeFinished: io.string,
  timeQueued: io.string,
  timeStarted: io.string,
  type: io.literal(JOB_TYPE_EXECUTION),
  version: io.string,
});
